import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {FlightModeGameAssets} from "../../FlightModeGameAssets";

export class FlightModeForegroundElements extends PIXI.Container implements StageLayer {
    private logo:PIXI.Sprite;

    constructor() {
        super();
        this.name = "FlightModeForegroundElements";

        this.logo = new PIXI.Sprite(ImgLoader.getImgTexture(FlightModeGameAssets.IMAGES_LOGO));
        this.logo.scale.set(0.65,0.65);
        this.logo.anchor.set(0.5,0.5);
        this.addChild(this.logo);

        this.onResize();
    }

    public onOrientationChanged() {}

    public onResize() {
        if (NolimitApplication.isLandscape){
            this.logo.scale.set(0.65, 0.65);
            this.logo.position.set((NolimitApplication.screenBounds.left - 20) / 2, 80);
            this.logo.visible = -(NolimitApplication.screenBounds.left - 20) > (this.logo.width);
        } else {
            this.logo.scale.set(1,1);
            this.logo.position.set(360, (NolimitApplication.screenBounds.top + 44) / 2);
            this.logo.visible = -(NolimitApplication.screenBounds.top) > (this.logo.height - 18);
        }
    }
}